import React from "react";

const BlogCard = ({ blog }) => {
  return (
    <div className="flex flex-col">
      {/* Banner */}
      <div className="w-full h-60 bg-gray-100 rounded-lg overflow-hidden">
        <img
          src={blog.img}
          alt={blog.title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Category + Title */}
      <div className="mt-4">
        <span
          className={`px-3 py-1 rounded-full text-sm font-medium ${blog.tagColor}`}
        >
          {blog.category}
        </span>
        <h3 className="mt-3 text-lg font-semibold">{blog.title}</h3>
        <p className="text-sm text-gray-500 mt-1">Posted on {blog.date}</p>
      </div>
    </div>
  );
};

export default BlogCard;
